import { CustomeTripQuestion } from "../../pre-post-trip-question/models/custom-question.model";

export class VehicleModel {
  public vehicleID: number;
  public vehicleMasterHashId: string;
  public licenceTag: string;
  public ownerCompanyHashID: string = "";
  public vehicleGroupMappingHashId: string;
  public ownerCompanyID: string;
  public ownerName: string;
  public locationDataExchangeId: number;
  public locationDataExchangeHashId: string = "";
  public availableFromDatetime: string;
  public availableToDatetime: string;
  public available: boolean = true;
  public type: string;
  public brand: string;
  public color: string;
  public vehicleClass: string;
  public pricingCategory: string;
  public bodyStyle: string;
  public vtsLicenceNamePlate: string;
  // public towbar: boolean;
  public fuelType: string;
  public fuelCardPinCode: string;
  public doors: number; 
  public weight: number; 
  public trunkSpace: number; 
  public gears: number; 
  public engineHorsepower: number; 
  public fuelConsumption: string; 
  public seats: number; 
  public dimensions: string; 
  public transmissionType: string = "";
  public vin: string;
  public vehicletypeList: string;

  // public airco: boolean;
  public minBookingTimeBefore: string;
  public minBookingTimeAfter: string;
  public isChecked: boolean;
  public attributeList: string[] = [];
  public vehicleGeoLocationAddress: string;
  public displayGeoLocationAddress: string;
  public vehicleGeoLocationLatitude: number;
  public vehicleGeoLocationLongitude: number;
  public reason: string;
  public vehicleImagePath: string;
  public isFuelRequire: boolean = false;
  public isCleaningRequire: boolean = false;
  public vtsLocation: string;
  public isVehicleDamage: boolean;
  public isGefenceEnabled: boolean = false;
  public geofenceAttributeModel: GeofenceAttributeModel;
  public homeLocationModel: HomeLocationModel;
  public isHomeLocationEnabled: boolean;
  public apkExpirationDate: string;
  public userProvidedOdometerValueInKm: number;
  public calculateOdometerValue: number;
  public currentOdometerDateTime: string;
  public bookingStatus: string;
  public earlyOpenInterval: number;
  public dashboardStatus: string;
  public inUseBookingDetail: InUseBookingDetail;
  public showVehicleChargeLevel: string = "INHERIT";
  public chargeLevel: string;
  public filling: boolean;
  public batteryVoltage: string;
  public lowBatteryFlagRaised: string;
  public lowBatteryFlagClear: string;
  public isEditable: boolean;
  public isDeletable: boolean;
  public isViewable: boolean;
  public isCompanyEditable: boolean;
  public isVTSTroubleshootEnable: boolean;
  public customTripQuestionList: Array<CustomeTripQuestion>;
  public instanceLanguage: string = 'en';
  public license: string;
  public certificates: string;
  public invalidTagUsed: boolean = false;
  public tagAccessDisabled: boolean = false;
  //WEGO2DEV-325(Settings for Dashboard statuses)
  // public locationVehicleTime : number;
  // public locationTimeInterval : string = "";
  // public bookedBeforeTime : number;
  // public bookedBeforeInterval : string = "";

  constructor() {
    this.geofenceAttributeModel = new GeofenceAttributeModel();
    this.homeLocationModel = new HomeLocationModel();
    this.inUseBookingDetail = new InUseBookingDetail();
    this.customTripQuestionList = new Array<CustomeTripQuestion>();
  }
}

export class InUseBookingDetail {
  public bookingMasterHashId: string;
  public bookingReferenceID: string;
}

export class VehicleBlockModel {
  public vehicleHashId: string;
  public reason: string;
  public activeFlag: boolean;
}

export class SVGVehicleModel {
  public vehicleHashId: string;
  public sharedvehiclegroupHashId: string;
  public listOfVehicleHashId: string[] = [];
}

export class VTSVehicleModel {
  public vehicleMasterHashId: string;
  public licenceTag: string;
  public fleetId: string = "52275965BBRACCGEO";
  public contractId: string = "52275965";
  public vin: string;
  public isEditable: boolean;
  // public type: string;
  // public brand: string;
  // public color: string;
  public obuType: string;
  public deviceId: string;
  public phoneNumber: string;
  public claimCode: string;
  public link: string;
}
export class GeofenceAttributeModel {
  public address: string;
  public latitude: string;
  public longitude: string;
  public radiusInMtr: string;
}
export class HomeLocationModel {
  public address: string;
  public latitude: string;
  public longitude: string;
  public radiusInMtr: string;
}

export class VehicleMappingModel {
  public vehicleHashId: string;
  public organizationHashId: string;
  public listOfvehicleHashId: string[] = [];
  public customerHashId: string;
  public instanceHashId: string;
  public companyHashId: string;
  public svgHashId: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/vehicle/models/vehicle.model.ts